export class LocalDbSettings {
  constructor(db) {
    this.db = db;
  }

  getSettings() {
    let transaction = this.db.transaction("settings");
    let settings = transaction.objectStore("settings");
    let request = settings.getAllKeys();

    return new Promise(function (resolve, reject) {
      request.onerror = function () {
        reject(new Error("Database getSettings() error"));
      };
      request.onsuccess = function () {
        resolve(request.result);
      };
    });
  }

  getSetting(key) {
    let transaction = this.db.transaction("settings");
    let settings = transaction.objectStore("settings");
    let request = settings.get(key);

    return new Promise(function (resolve, reject) {
      request.onerror = function () {
        reject(new Error("Database getSetting() error"));
      };
      request.onsuccess = function () {
        resolve(request.result);
      };
    });
  }

  setSetting(key, value) {
    let transaction = this.db.transaction("settings", "readwrite");
    let settings = transaction.objectStore("settings");
    let request = settings.put(
      // костыль, так как нельзя сохранять объекты, которые внутри имеют ссылки
      JSON.parse(JSON.stringify(value)),
      key
    );

    return new Promise(function (resolve, reject) {
      request.onerror = function () {
        reject(new Error("Database getSetting() error"));
      };
      request.onsuccess = function () {
        resolve(request.result);
      };
    });
  }

  deleteSetting(key) {
    let transaction = this.db.transaction("settings", "readwrite");
    let settings = transaction.objectStore("settings");
    let request = settings.delete(key);

    return new Promise(function (resolve, reject) {
      request.onerror = function () {
        reject(new Error("Database deleteSetting() error"));
      };
      request.onsuccess = function () {
        resolve();
      };
    });
  }
}
